import { render } from "./CompanyBox.vue?vue&type=template&id=6b6cea4a&scoped=true"
import script from "./CompanyBox.vue?vue&type=script&lang=js"
export * from "./CompanyBox.vue?vue&type=script&lang=js"

import "./CompanyBox.vue?vue&type=style&index=0&id=6b6cea4a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b6cea4a"]])

export default __exports__